import { render, staticRenderFns } from "./UploadFreeChips.vue?vue&type=template&id=28ebe1c0&scoped=true&"
import script from "./UploadFreeChips.vue?vue&type=script&lang=js&"
export * from "./UploadFreeChips.vue?vue&type=script&lang=js&"
import style0 from "./UploadFreeChips.vue?vue&type=style&index=0&id=28ebe1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ebe1c0",
  null
  
)

export default component.exports